module["exports"] = [
  "Canada"
];



/*****************
 ** WEBPACK FOOTER
 ** ./~/faker/lib/locales/en_CA/address/default_country.js
 ** module id = 498
 ** module chunks = 0
 **/